import { call, put, takeLatest } from 'redux-saga/effects';

import { get2NDFL } from '../../services/API';
import {
  actionTypes,
  requestFailure,
  requestSuccess,
} from 'modules/UserIncomes/redux/2ndfl/actions';

function* getData() {
  const response = yield call(get2NDFL);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* ndfl2Saga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
